import { useState } from 'react';
import { BiEditAlt, BiTrashAlt, BiCalendar } from 'react-icons/bi'
import { useClube } from '../contextClube'
import moment from 'moment'

import { Container, Slider } from './style';

export function PostPreview({ 
    datas, 
    handleClickEditButton, 
    handleClickActiveButton,
    handleClickToDelete 
}) {
    const { setDatasToEdit, setModalFormsIsOpen } = useClube()
    const [switchButtonActive, setSwitchButtonActive] = useState(datas.active)

    const initialDate = moment(datas.initDate.slice(0, 16)).format('DD/MM/YYYY')
    const finalDate = datas.lastDate === null || datas.lastDate === ''  ? '-' : moment(datas.lastDate.slice(0, 16)).format('DD/MM/YYYY')

    function handleEdit() {
        setDatasToEdit(datas)
        handleClickEditButton()
        setModalFormsIsOpen(true)
    }

    return(
        <Container src={datas.image}>
            <div className="buttonsConfig">
                <BiTrashAlt onClick={() => handleClickToDelete(datas.id)}/>
                <BiEditAlt onClick={handleEdit} />
                <Slider 
                    onClick={() => {
                        setSwitchButtonActive(!switchButtonActive)
                        handleClickActiveButton(datas.id, !switchButtonActive)
                    }}
                    switchButtonActive={switchButtonActive} 
                >
                    <div className="circle"/>
                </Slider>
            </div>

            <div className="image" />

            <div className="info">
                <p>{datas.title}</p>
                <div>
                    <BiCalendar />
                    <time>{initialDate}</time>
                </div>
                <div>
                    <BiCalendar />
                    <time>{finalDate}</time>
                </div>
            </div>
        </Container>
    )
}
